// Links
// Features:
// - Displays fixed social media links (LinkedIn, X)
// - Uses persistent inline styles for simple UI elements

const CONTAINER_STYLE = {
    position: 'fixed',
    right: 16,
    bottom: 16,
    display: 'flex',
    gap: 12,
    zIndex: 10010,
    pointerEvents: 'auto',
}

const LINK_BASE_STYLE = {
    width: 36,
    height: 36,
    borderRadius: '50%',
    border: '2px solid rgba(255,255,255,0.9)',
    display: 'grid',
    placeItems: 'center',
    textDecoration: 'none',
    fontFamily:
        'system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
    lineHeight: 1,
    boxShadow: '0 2px 6px rgba(0,0,0,0.35)',
}

const LINKEDIN_STYLE = {
    ...LINK_BASE_STYLE,
    background: '#0A66C2',
    color: '#fff',
    fontWeight: 700,
    fontSize: 16,
}

const X_STYLE = {
    ...LINK_BASE_STYLE,
    background: '#000000',
    color: '#ffffff',
    fontWeight: 800,
    fontSize: 15,
}

export default function Links() {
    return (
        <div style={CONTAINER_STYLE}>
            <a
                href="https://www.linkedin.com/in/mesqme/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                style={LINKEDIN_STYLE}
            >
                in
            </a>
            <a
                href="https://x.com/mesqme"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="X"
                style={X_STYLE}
            >
                X
            </a>
        </div>
    )
}
